import styled from "styled-components";
import { ButtonTag } from '../../components/Button/styles';
import { InputTag } from '../../components/Input/styles';

export const Container = styled.div`
  width: 100%;
  max-width: 230px;
  
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -25px;
  margin-bottom: 20px;
  
  font-size: 14px;
  line-height: 18px;
  
  svg {
    margin-bottom: 20px;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  
  margin-bottom: 10px;
`;

export const Input = styled(InputTag)`
  font-weight: 400;
  text-align: left;
  
  border: 1px solid #ebebeb;
  border-radius: 6px;
  
  transition: border-color 0.3s;
  
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const Error = styled.p`
  display: flex;
  width: 100%;
  justify-content: center;
  position: absolute;

  bottom: -40px;
  padding: 0;

  font-size: 14px;
  color: ${({ theme }) => theme.red};
`;

export const SubmitButton = styled(ButtonTag)`
  margin-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
`;

export const Disclaimer = styled.p`
  font-size: 10px;
  line-height: 14px;
  text-align: center;
`;
